import React, { useState } from "react";
import { Link } from "react-router-dom";
import AuthShell from "@/components/AuthShell";
import API, { formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try { await API.post("/auth/forgot-password", { email }); } catch {}
    setDone(true); setLoading(false);
  };

  return (
    <AuthShell title="Password dimenticata" subtitle="Ti invieremo un link per reimpostarla.">
      {done ? (
        <div data-testid="forgot-done">
          <p className="text-[#2A2E48]">Se l'email è registrata, ti abbiamo inviato un link per reimpostare la password.</p>
          <Link to="/login" className="text-[#141A3A] font-medium mt-4 inline-block">Torna all'accesso</Link>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
          <div><Label>Email</Label><Input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" /></div>
          <Button type="submit" data-testid="forgot-submit" disabled={loading} className="w-full h-12 bg-[#FFD23F] hover:bg-[#F2C200] text-[#0F1230] rounded-full">
            {loading ? "Invio..." : "Invia link"}
          </Button>
          <Link to="/login" className="text-[#141A3A] text-sm inline-block">Torna all'accesso</Link>
        </form>
      )}
    </AuthShell>
  );
}
